var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{class:{'ma-2': _vm.$vuetify.breakpoint.smAndDown, 'ma-5': _vm.$vuetify.breakpoint.mdAndUp},attrs:{"value":true,"type":"error"}},[_c('h4',[_vm._v("No accounts are available!")]),_c('hr'),_c('p',[_vm._v("Your user does not belong to any accounts.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }